import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import {
  NORMAL,
  UNAVAILABLE,
  ERROR,
  AVAILABLE,
} from 'app/constants/statusColors'
import { SENT, UNSENT, DRAFT, SCHEDULED } from 'app/constants/messageDetail'

import StatusChip from 'app/componentV4/Status/Chip'

const Status = (props) => {
  const { status, className } = props
  const { formatMessage } = useIntl()

  const [data, setData] = useState({ label: '', type: '' })

  useEffect(() => {
    switch (status) {
      case SENT:
        return setData({
          label: formatMessage({ id: 'text.sent' }),
          type: NORMAL,
        })
      case UNSENT:
        return setData({
          label: formatMessage({ id: 'text.unsent' }),
          type: ERROR,
        })
      case DRAFT:
        return setData({
          label: formatMessage({ id: 'text.draft' }),
          type: UNAVAILABLE,
        })
      case SCHEDULED:
        return setData({
          label: formatMessage({ id: 'text.scheduled' }),
          type: AVAILABLE,
        })
      default:
        return
    }
  }, [formatMessage, status])

  return (
    <div className={clsx(className)}>
      <StatusChip type={data.type} label={data.label} />
    </div>
  )
}

Status.propTypes = {
  status: PropTypes.string,
  className: PropTypes.string,
}

export default Status
